export const API_DOMAIN =
  process.env.REACT_APP_API_DOMAIN || 'http://localhost:3000';
